module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-l-50 w-500"
  }, [_c('el-form', {
    ref: "pipeLine",
    attrs: {
      "model": _vm.pipeLine
    }
  }, [_c('p', [_vm._v("WEB消息提醒")]), _vm._v(" "), _c('div', {
    staticClass: "channel-content m-b-20"
  }, _vm._l((_vm.pipeLine.web), function(item, index) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": "名称",
        "prop": 'web.' + index + '.name',
        "rules": {
          required: true,
          message: '名称不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      attrs: {
        "placeholder": "请输入姓名"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          item.name = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "通道标识",
        "prop": 'web.' + index + '.sign',
        "rules": {
          required: true,
          message: '通道标识不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.sign),
        expression: "item.sign"
      }],
      attrs: {
        "placeholder": "请输入通道标识"
      },
      domProps: {
        "value": (item.sign)
      },
      on: {
        "input": function($event) {
          item.sign = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "秘钥",
        "prop": 'web.' + index + '.config.secret',
        "rules": {
          required: true,
          message: '秘钥不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.config.secret),
        expression: "item.config.secret"
      }],
      attrs: {
        "placeholder": "请输入秘钥"
      },
      domProps: {
        "value": (item.config.secret)
      },
      on: {
        "input": function($event) {
          item.config.secret = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "消息类型"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.msg_type),
        expression: "item.msg_type"
      }],
      attrs: {
        "placeholder": "请输入主题"
      },
      domProps: {
        "value": (item.msg_type)
      },
      on: {
        "input": function($event) {
          item.msg_type = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "消息主题"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.msg_theme),
        expression: "item.msg_theme"
      }],
      attrs: {
        "clearable": "",
        "placeholder": "请选择"
      },
      domProps: {
        "value": (item.msg_theme)
      },
      on: {
        "input": function($event) {
          item.msg_theme = $event
        }
      }
    }, _vm._l((_vm.theme_list), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item,
          "value": item
        }
      })
    }))])])
  })), _vm._v(" "), _c('p', [_vm._v("企业微信")]), _vm._v(" "), _c('div', {
    staticClass: "channel-content m-b-20"
  }, [_vm._l((_vm.pipeLine.wechat), function(item, key) {
    return _c('div', {
      staticClass: "wechat-wrap"
    }, [_c('div', {
      staticClass: "m-b-10 border-b-1 w-400"
    }, [_c('el-form-item', {
      attrs: {
        "label": "名称",
        "prop": 'wechat.' + key + '.name',
        "rules": {
          required: true,
          message: '名称不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      attrs: {
        "placeholder": "请输入企业微信姓名"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          item.name = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "通道标识",
        "prop": 'wechat.' + key + '.sign',
        "rules": {
          required: true,
          message: '通道标识不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.sign),
        expression: "item.sign"
      }],
      attrs: {
        "placeholder": "请输入企业微信通道标识"
      },
      domProps: {
        "value": (item.sign)
      },
      on: {
        "input": function($event) {
          item.sign = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "应用ID",
        "prop": 'wechat.' + key + '.config.agent_id',
        "rules": {
          required: true,
          message: '应用ID不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.config.agent_id),
        expression: "item.config.agent_id"
      }],
      attrs: {
        "placeholder": "请输入企业微信应用ID"
      },
      domProps: {
        "value": (item.config.agent_id)
      },
      on: {
        "input": function($event) {
          item.config.agent_id = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "秘钥",
        "prop": 'wechat.' + key + '.config.secret',
        "rules": {
          required: true,
          message: '秘钥不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.config.secret),
        expression: "item.config.secret"
      }],
      attrs: {
        "placeholder": "请输入企业微信通秘钥"
      },
      domProps: {
        "value": (item.config.secret)
      },
      on: {
        "input": function($event) {
          item.config.secret = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "消息类型"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.msg_type),
        expression: "item.msg_type"
      }],
      attrs: {
        "placeholder": "请输入主题"
      },
      domProps: {
        "value": (item.msg_type)
      },
      on: {
        "input": function($event) {
          item.msg_type = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "消息主题"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.msg_theme),
        expression: "item.msg_theme"
      }],
      attrs: {
        "clearable": "",
        "placeholder": "请选择"
      },
      domProps: {
        "value": (item.msg_theme)
      },
      on: {
        "input": function($event) {
          item.msg_theme = $event
        }
      }
    }, _vm._l((_vm.theme_list), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item,
          "value": item
        }
      })
    }))])]), _vm._v(" "), (item.id) ? _c('i', {
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delExisted(item)
        }
      }
    }) : _c('i', {
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delNew(key)
        }
      }
    }), _vm._v(" ")])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addWeChat
    }
  }, [_vm._v("再添加一个企业微信应用的消息通道")])], true), _vm._v(" "), _c('p', [_vm._v("消息推送IP白名单")]), _vm._v(" "), _c('div', {
    staticClass: "channel-content"
  }, [(_vm.white_list.length > 0) ? _c('ul', {
    staticClass: "white-list"
  }, _vm._l((_vm.white_list), function(item, key) {
    return _c('li', {
      staticClass: "m-l-10 m-b-10"
    }, [_c('span', [_vm._v(_vm._s(item))]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          _vm.delWhite(key)
        }
      }
    })])
  })) : _c('p', {
    staticClass: "m-l-10 empty"
  }, [_vm._v("目前没有IP白名单")]), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "m-b-10 ovf-hd m-l-10"
  }, [_c('div', {
    staticClass: "fl w-300"
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.whiteIp),
      expression: "whiteIp"
    }],
    attrs: {
      "placeholder": "输入IP白名单"
    },
    domProps: {
      "value": (_vm.whiteIp)
    },
    on: {
      "input": function($event) {
        _vm.whiteIp = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl m-l-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addIp
    }
  }, [_vm._v("新增IP")])])])]), _vm._v(" "), _c('el-button', {
    staticClass: "m-t-20",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.save('pipeLine')
      }
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "m-l-50 m-t-30 w-650"
  }, [_c('p', [_vm._v("调用说明")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_vm._v("调用接口地址：" + _vm._s(_vm.intro_url))]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_vm._v("调用接口类型：" + _vm._s(_vm.intro_method))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.intro_params,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "参数名",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "数据类型",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "intro",
      "label": "说明",
      "width": "350"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_vm._v("例子:")]), _vm._v(" "), _c('div', {
    staticClass: "channel-content m-t-10"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('pre', [_vm._v(_vm._s(_vm.intro_example))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c65d85d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/message/channel.vue
// module id = 1938
// module chunks = 2